import { useState, useEffect } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { updateUserPreferences } from "api/UserApi";
import { useAuth0 } from "@auth0/auth0-react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

function TwoStepAuthentication() {
  const { user } = useAuth0();
  const [toggle, setToggle] = useState(false);
  const { userPreferences } = useSelector((store) => store?.portal?.users);

  const handleToggle = async () => {
    try {
      userPreferences.twostepauthentication = !toggle;
      const { designer, ...restPreferences } = userPreferences;
      await updateUserPreferences(user?.cxfUserId, user?.stripeId, restPreferences);
      toast.success(
        !toggle
          ? "Successfully enabled two-step authentication"
          : "Successfully disabled two-step authentication"
      );
      setToggle(!toggle);
    } catch (error) {
      console.error("Error updating two-step authentication:", error);
    }
  };

  useEffect(() => {
    const isTwoStepEnabled = userPreferences?.twostepauthentication ?? false;
    setToggle(isTwoStepEnabled);
  }, [userPreferences]);

  return (
    <Card id="show-access-token" sx={{ boxShadow: "none !important" }}>
      <SoftBox pt={2} px={2} lineHeight={1} sx={{ position: "relative" }}>
        <div style={{ display: "flex" }}>
          <div style={{ marginRight: "10px" }}>
            <Switch onChange={handleToggle} checked={toggle} />
          </div>
          <div>
            <SoftTypography variant="h6" fontWeight="medium">
              Enable Two-Step Authentication
            </SoftTypography>
            <SoftTypography variant="button" fontWeight="regular" color="text">
              This will enable two-step authentication next time you sign in.
            </SoftTypography>
          </div>
        </div>
      </SoftBox>

      <SoftBox pb={2} />
    </Card>
  );
}

export default TwoStepAuthentication;
